import WorkflowGraph from "../../../formability/form_builder/models/workflow/workflowGraph";
import {INavigableValidatableModel} from "~/interfaces/navigableValidationInterfaces";
import NavigableValidator from "./navigableValidator";
import {ErrorType} from "~/enums/ErrorType";
import ValidationError from "../validationError";
import WorkflowStep from "../../../formability/form_builder/models/workflow/workflowStep";
import initialStep from "../../../formability/form_builder/models/workflow/initialStep";

export enum BrokenWorkflowErrorType {
  LoopError = "WORKFLOW_LOOP_ERROR",
  WorkflowError ="WORKFLOW_ERROR"
}

export default class BrokenWorkflowStepsValidator<T> extends NavigableValidator<T> {
  defaultMessage = "Workflow is broken. In it's current state a path can be traversed that has no end.";
  defaultType = ErrorType.brokenWorkflow;

  protected _validate(model: INavigableValidatableModel<T>): void {
    let workflowSteps = this.getWorkflowSteps(model);
    const workflowGraph = new WorkflowGraph(workflowSteps[0], [0, 0]);
    const brokenSteps = workflowGraph.brokenWorkFlowSteps();
    if (brokenSteps.length !== 0){
      brokenSteps.forEach(brokenStep =>{
        this.errors.push(this.buildValidationError(model, brokenStep, this.options.message || this.defaultMessage, this.getName(brokenStep), this.getErrorType(brokenStep) ));
      });
    }
  }

  getWorkflowSteps(model): WorkflowStep[] {
    return Object.keys(model.workflow_steps)
      .map(key => model.workflow_steps[key])
      .sort((a, b) => a.sort_order - b.sort_order);
  }

  getName(model): string{
    if (model instanceof initialStep){
      return "Workflow Loop"
    } else {
      return model.titleOrDefault
    }
  }

  getErrorType(model): string{
    if (model instanceof initialStep) {
      return BrokenWorkflowErrorType.WorkflowError
    } else{
      return BrokenWorkflowErrorType.LoopError
    }
  }

  buildValidationError(form, workflowStep, value?, name?, errortype?, type?) {
    return new ValidationError({
      message: value || this.options.message || this.defaultMessage,
      displayName: name || `Broken Workflow`,
      errorNavOpts: form.validation.errorNavOpts(this, this.validatorKey, workflowStep, errortype),
      type: type || this.defaultType,
      section: this.section
    });
  }
}
